// extracted by mini-css-extract-plugin
export default {"root":"tx_dp","child":"I1vfV","full":"_S5aN","half":"ojMjM","small":"FQIcQ","empty":"jQFtN"};